import { DSModal } from "@components/design-system/organisms";

const ConfirmTemplateConstructionModal = ({
  shouldShow,
  hideModal,
  confirmAction,
}) => (
  <DSModal
    isOpen={shouldShow}
    onClose={hideModal}
    title="Switch Template Construction"
    actions={[
      { label: "Cancel", variant: "cancel", onClick: hideModal },
      {
        label: "Switch",
        variant: "primary",
        onClick: confirmAction,
        dataTestId: "confirm-button",
      },
    ]}
    dataTestId="confirm-template-construction-modal"
  >
    <p>
      Changing the template construction will erase all data you've
      entered so far for this template.{" "}
      <b>This action cannot be undone.</b>
    </p>
    <p>Are you sure you want to proceed?</p>
  </DSModal>
);

export default ConfirmTemplateConstructionModal;
